import { Fragment, useContext } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import {
  submissionCaseForTimesUp,
  submissionExamContentForReview,
} from "../../environment";

import Countdown from "react-countdown";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 0,
};

type SubmitAlertProps = {
  isOpen: boolean;
  handleClose: any;
  width?: number;
  isReview?: boolean;
  reviewAction?: () => void;
  submitAction: () => Promise<void>;
  children?: ReactNode;
  isTimeOver: boolean;
  cancelAction?: (isReview?: boolean) => void;
  submitCallback?: () => void;
  timeOverCallback?: () => void;
};

const SubmitAlert: FC<SubmitAlertProps> = ({
  isReview,
  isOpen,
  handleClose,
  submitAction,
  reviewAction,
  width =  600,
  children,
  isTimeOver,
  cancelAction,
  submitCallback,
  timeOverCallback,
}): JSX.Element => {
  const renderer = ({ hours, minutes, seconds, completed }: any) => {
    if (completed) {
      return <></>;
    } else {
      return (
        <span style={{ fontWeight: "bold", color: "red" }}>
          {hours < 10 ? `0${hours}` : hours}:
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };
  if (!isOpen) return <></>;


  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={() => {
        if (isTimeOver) {
          submitAction?.();
          timeOverCallback?.();
        } else handleClose();
      }}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={isOpen} className="p-0">
        <Box sx={[style, { width: { xs: 340, md: 700 } }]}>
          <Box className="bg-[#2563eb] py-1">
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              className="text-white text-center"
            >
              {isReview
                ? `${submissionExamContentForReview.title}`
                : isTimeOver
                ? `${submissionCaseForTimesUp.title}`
                : `${submissionExamContentForReview.title}`}
            </Typography>
          </Box>
          <Box className="  mb-1 p-0  ">
            <Typography
              variant="body1"
              id="transition-modal-description"
              sx={{
                mt: isTimeOver ? 3 : 1,
                // textTransform: "capitalize",
                textAlign: "center",
              }}
            >
              {isReview
                ? `${submissionExamContentForReview.subtitle}`
                : isTimeOver
                ? `${submissionCaseForTimesUp.subtitle}`
                : `${submissionExamContentForReview.subtitle}`}
            </Typography>

            {!isTimeOver ? (
              <Fragment>
                <Box
                  sx={{ px: 2, display: "flex", alignItems: "center", mt: 1 }}
                >
                  <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                  <Typography
                    id="transition-modal-description"
                    sx={{
                      // textTransform: "capitalize",
                      fontSize: "12px",
                      ml: { xl: "9px", lg: "6px", sm: "4px" },
                    }}
                  >
                    {isReview
                      ? `${submissionExamContentForReview.desc}`
                      : `${submissionExamContentForReview.desc}`}
                  </Typography>
                </Box>
                {isReview && children ? (
                  <Fragment>
                    <Box
                      sx={{
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                        mt: 1,
                      }}
                    >
                      <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                      {children}
                    </Box>
                    <Box
                      sx={{
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                        mt: 1,
                      }}
                    >
                      {/* <FiberManualRecordIcon sx={{ fontSize: "11px" }} /> */}
                      <Typography
                        id="transition-modal-description"
                        sx={{
                          // textTransform: "capitalize",
                          fontSize: "12px",
                          ml: { xl: "9px", lg: "6px", sm: "4px" },
                        }}
                      >
                        {isReview
                          ? `${submissionExamContentForReview.subDesc}`
                          : ``}
                      </Typography>
                    </Box>
                  </Fragment>
                ) : (
                  <></>
                )}

                {isReview ? (
                  <Box
                    sx={{ px: 2, display: "flex", alignItems: "center", mt: 1 }}
                  >
                    <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                    <Typography
                      id="transition-modal-description"
                      sx={{
                        // textTransform: "capitalize",
                        fontSize: { md: "12px", xs: "10px" },
                        ml: { xl: "9px", lg: "6px", sm: "4px" },
                      }}
                    >
                      {isReview
                        ? `${submissionExamContentForReview.actionText}`
                        : ``}
                    </Typography>
                  </Box>
                ) : (
                  <></>
                )}
                {isReview ? (
                  <Box className="flex items-center justify-around px-2  mt-5 border-t py-2  border-gray-200">
                    <button
                      onClick={() => handleClose()}
                      className="md:px-10 px-3 flex items-center justify-center uppercase py-1   bg-white border border-blue-600   text-blue-600 hover:text-black hover:bg-blue-600 hover:text-white   "
                    >
                      No
                    </button>
                    {/* <button
                      onClick={() => reviewAction?.()}
                      className="md:px-10 px-5 flex items-center justify-center uppercase py-1  border border-[#2563eb] hover:bg-blue-600 transition-all duration-500 hover:text-white "
                    >
                      No
                    </button> */}
                    <button
                      onClick={() => {
                        submitAction?.();
                        submitCallback?.();
                      }}
                      className="md:px-10 px-4 flex items-center justify-center uppercase py-1   bg-blue-600  text-white hover:text-black hover:bg-white border border-transparent hover:border-blue-600 "
                    >
                      Yes
                    </button>
                  </Box>
                ) : (
                  <Box className="flex items-center justify-center px-2 gap-x-3  mt-5 border-t py-2  border-gray-200">
                    <button
                      onClick={() => {
                        submitAction?.();
                        submitCallback?.();
                      }}
                      className="px-10 flex items-center justify-center uppercase py-1   bg-blue-600  text-white hover:text-black hover:bg-white border border-transparent hover:border-blue-600 "
                    >
                      Submit
                    </button>
                    <button
                      onClick={() => cancelAction?.()}
                      className="px-10 flex items-center justify-center uppercase py-1   bg-white border border-blue-600   text-blue-600 hover:text-black hover:bg-blue-600 hover:text-white   "
                    >
                      Cancel
                    </button>
                  </Box>
                )}
              </Fragment>
            ) : (
              <></>
            )}
            {isTimeOver && (
              <Box className="flex items-center justify-center px-2 gap-x-4  mt-5 border-t py-2  border-gray-200">
                <button
                  onClick={() => {
                    submitAction?.();
                    timeOverCallback?.();
                  }}
                  className="px-10 flex items-center justify-center uppercase py-1   bg-blue-600  text-white hover:text-black hover:bg-white border border-transparent hover:border-blue-600 "
                >
                  Submit
                </button>
              </Box>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SubmitAlert;
